namespace Solovis.Site.SiteHeader {

    export function init() {
        let headerJumpBoxElement = $("#headerJumpBox");
        let helpLinkElement = $("#headerLinkForHelp");
        let siteFeedbackLinkElement = $("#siteFeedbackLink");
        let featuredLinkElement = $("#headerLinkForFeaturedLinks");
        let loginLinkElement = $("#loginLink");

        headerJumpBoxElement.click(async function () {
            Solovis.Site.JumpBox.showJumpBox(this);
        });

        helpLinkElement.click(function () {
            Solovis.Site.HelpManager.showHelpMenu(this);
        });

        featuredLinkElement.click(function () {
            var self = this;

            featuredLinkElement.addClass("active");

            var featuredLinks = [];

            featuredLinks.push({
                label: "View Featured Links",
                click: function () { Solovis.Portal.FeaturedLinks.showFeaturedLinksInDialog(); }
            });

            featuredLinks.push({ separator: true });

            if (Solovis.Portal.FeaturedLinks.canUpdateFeaturedLink()) {
                featuredLinks.push({
                    label: "Update Current Featured Link",
                    click: function () { Solovis.Portal.FeaturedLinks.updateFeaturedLink(); }
                });
            }

            featuredLinks.push({
                label: "Save Page As New Featured Link",
                click: function () { Solovis.Portal.FeaturedLinks.showSavePageAsFeaturedLink(); }
            });
            featuredLinks.push({
                label: "Manage Featured Links",
                href: "~/DataManagement/UserFeaturedLinks"
            });

            var featuredLinkPanel = Solovis.UI.PopupLinkPanel.showLinks({
                offsetElement: self,
                offsetRight: true,
                offsetBottom: true,
                fromRightEdge: true,
                links: featuredLinks,

                close: function () {
                    featuredLinkElement.removeClass("active");
                }
            });
        });

        loginLinkElement.click(function () {
            const showUxToggle = Solovis.UX.Utils.isUserEligibleForNewUx();
            loginLinkElement.addClass("active");

            const links = showUxToggle ? [
                { label: "My Account", href: "~/MyAccount" },
                { label: "New Version", dataTestId: "new-version-toggle", 
                    click: function() {
                        Solovis.UX.Utils.setUxState(true).then(() => {
                            location.reload();
                        })
                    }
                },
                { separator: true },
                { label: "Log Off", href: "~/Account/Logout" }
            ] : [
                { label: "My Account", href: "~/MyAccount" },
                { separator: true },
                { label: "Log Off", href: "~/Account/Logout" }
            ]

            var loginLinkPanel = Solovis.UI.PopupLinkPanel.showLinks({
                offsetElement: this,
                offsetRight: true,
                offsetBottom: true,
                fromRightEdge: true,
                links: links,

                close: function () {
                    loginLinkElement.removeClass("active");
                }
            });
        });

        if (Solovis.Portal.CachedModuleOptions.isEnabled("DataPack")) {
            // Show selector for data packs in top banner.
            $("#data-pack-selection-div").css("display", "block");
            $("#dataPackSelectionLink").click(() => {
                (Solovis as any).Reports.DataPacks.DataPackSelector.showDataPackSelectorDialog();
            });      

            // bannerControl will be visible if default data pack is selected.
            var bannerElement = $("#header-datapack-container");
            var bannerControl = new (Solovis as any).Reports.DataPacks.DataPackBannerControl({
                controlHost: bannerElement,
                bannerElement: bannerElement
            });
            bannerControl.setAsCurrentControl();            
        }
        
        if (!Solovis.UX.Utils.isNewUxEnabled()) {
            SiteHeader._keepHeaderHorizontallyOnPage();
        }
    }

    export function _keepHeaderHorizontallyOnPage() {
        var header = $("body header").get(0);
        var headerTitleBar = $("div.header-title-bar-container").get(0);
        if (header || headerTitleBar) {
            var headerAdjust = function () {
                var windowWidth = $(window).width();
                var windowLeft = $(window).scrollLeft();

                $(header).width(windowWidth);
                $(header).css("margin-left", "" + windowLeft + "px");

                $(headerTitleBar).width(windowWidth);
                $(headerTitleBar).css("margin-left", "" + windowLeft + "px");
            };

            $(window).resize(headerAdjust);
            $(window).scroll(headerAdjust);
        }
    };   

    let headerRef:any = {
    };
    export async function setNewHeader(title: string, subTitle?: string) {
        Solovis.UX.Utils.loadNewExperienceDependencies().then(() => {
            Solovis.UX.Utils.placeComponent("SiteHeader", document.querySelector("#header-title-bar .title-section") as HTMLElement, {
                title,
                subTitle,
                ref: (ref) => {
                    headerRef = ref;
                }
            });
        });
    }

    async function updateNewHeaderTitle(title: string, subTitle?: string) {
        //wait for the title to be updated before calling
        let retries = 0;
        await Solovis.UX.Utils.until(() => ++retries == 3);

        if (headerRef && headerRef.updateTitle) {
            headerRef.updateTitle(title, subTitle);
        }
        else {
            setNewHeader(title, subTitle);
        }
    }

    export  function setTitle(title1, title2?) {
        if (Solovis.UX.Utils.isUserEligibleForNewReportHeader()) {
            updateNewHeaderTitle(title1, title2)
        }
        else {
            var titleContainer = $("#header-title-bar .title-section");

            titleContainer.html("");
            if (title1) {
                $("<div>").addClass("title-1").text(title1).appendTo(titleContainer);
            }
            if (title2) {
                $("<div>").addClass("title-2").text(title2).appendTo(titleContainer);
            }
        }
    }
}
